module.exports = __webpack_public_path__ + "img/ereszkalkulator_24_konyoktipusa_bal_konyok_szurke.a1eb9564.png";